module.exports = __webpack_public_path__ + "static/media/download4.d725d9c9.png";